require('babel-polyfill');
require('webrtc-adapter');

var KeaInstascan = {
  Scanner: require('./src/scanner'),
  Camera: require('./src/camera')
};

module.exports = KeaInstascan;



//////////////////
// WEBPACK FOOTER
// ./~/kea-instascan/index.js
// module id = 2195
// module chunks = 0